import isNumber from './is-number';

var isDecimal = function (num) {
  return isNumber(num) && num % 1 !== 0;
};

export default isDecimal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-decimal.js
// module id = 60
// module chunks = 0